import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_right",
  "use": "icon-arrow_right-usage",
  "viewBox": "0 0 14 8.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 8.6\" id=\"icon-arrow_right\">\n<polygon points=\"14,4.3 7.5,0 7.5,3.8 0,3.8 0,4.8 7.5,4.8 7.5,8.6 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol